import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qa-add-or-edit-event-popup b-blue-background b-add-edit__popup b-blue-background--fixed" }
const _hoisted_2 = { class: "b-popup-overflow--scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwSpinLoader = _resolveComponent("FwSpinLoader")!
  const _component_PrivatePopup = _resolveComponent("PrivatePopup")!
  const _component_EventPreviewInfo = _resolveComponent("EventPreviewInfo")!
  const _component_AddOrEditEventForm = _resolveComponent("AddOrEditEventForm")!
  const _component_AddOrEditEventFormUnavailability = _resolveComponent("AddOrEditEventFormUnavailability")!
  const _component_LimitedEditPopup = _resolveComponent("LimitedEditPopup")!
  const _component_FwPopup = _resolveComponent("FwPopup")!
  const _component_EditEventPopup = _resolveComponent("EditEventPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
          key: 0,
          colors: ["#fff", "#fff", "#fff"],
          class: "b-add-edit__popup--loading",
          isActive: _ctx.loading,
          className: "h-p-20"
        }, null, 8, ["isActive"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.privateEvent)
            ? (_openBlock(), _createBlock(_component_PrivatePopup, {
                key: 0,
                onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("close")))
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            (!_ctx.privateEvent)
              ? (_openBlock(), _createBlock(_component_FwPopup, {
                  key: 0,
                  ref: "eventPopup",
                  class: "b-popup-overflow--scroll-inner",
                  centered: true,
                  isFixed: true,
                  iconColor: "#BEC7D4",
                  "max-width": "800px",
                  width: "374px",
                  title: "",
                  padding: "0",
                  allowBackgroundScrolling: false,
                  showClosePopup: false,
                  popupBackground: "#ffffff",
                  popupRadius: "20px",
                  heightValue: "100%"
                }, {
                  body: _withCtx(() => [
                    (!_ctx.loading && _ctx.event && _ctx.showPreview)
                      ? (_openBlock(), _createBlock(_component_EventPreviewInfo, {
                          key: 0,
                          style: {"min-height":"650px"},
                          users: _ctx.users,
                          event: _ctx.event,
                          date: _ctx.date,
                          showAvatar: _ctx.showAvatar,
                          eventUserId: _ctx.eventAssignedMember,
                          isReservedSlotType: _ctx.isReservedSlotType,
                          editDeleteEvent: _ctx.editDeleteEvent,
                          onCurrentUserId: _ctx.updateCurrentUserId,
                          onUpdateAllData: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit("updateAllData"))),
                          onOpenDeletePopup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit("openDeletePopup"))),
                          onShowEditForm: _ctx.showEditForm,
                          onShowChooseEditPopup: _ctx.doShowChooseEditPopup,
                          onShowLimitedEditPopup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showLimitedEditPopup = true)),
                          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit("close")))
                        }, null, 8, ["users", "event", "date", "showAvatar", "eventUserId", "isReservedSlotType", "editDeleteEvent", "onCurrentUserId", "onShowEditForm", "onShowChooseEditPopup"]))
                      : (_ctx.isReservedSlotType)
                        ? (_openBlock(), _createBlock(_component_AddOrEditEventForm, {
                            key: 1,
                            style: {"min-height":"650px"},
                            event: _ctx.event,
                            date: _ctx.date,
                            users: _ctx.users,
                            eventUserId: _ctx.eventId,
                            propsSiteData: _ctx.userSiteData,
                            originValue: "user",
                            isFutureEdit: _ctx.isFutureEdit,
                            lunchBreakMap: _ctx.lunchBreakMap,
                            whBreakMap: _ctx.whBreakMap,
                            onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit("close"))),
                            onShowSubComponent: _ctx.showSubComponent,
                            onUpdateDate: _ctx.updateDate,
                            onRevertScrollPosition: _ctx.revertScrollPosition,
                            onUpdateAllData: _ctx.updateAllData
                          }, null, 8, ["event", "date", "users", "eventUserId", "propsSiteData", "isFutureEdit", "lunchBreakMap", "whBreakMap", "onShowSubComponent", "onUpdateDate", "onRevertScrollPosition", "onUpdateAllData"]))
                        : (_openBlock(), _createBlock(_component_AddOrEditEventFormUnavailability, {
                            key: 2,
                            style: {"min-height":"650px"},
                            event: _ctx.event,
                            date: _ctx.date,
                            users: _ctx.users,
                            eventUserId: _ctx.eventId,
                            isFutureEdit: _ctx.isFutureEdit,
                            propsSiteData: _ctx.userSiteData,
                            originValue: "unavailability",
                            lunchBreakMap: _ctx.lunchBreakMap,
                            whBreakMap: _ctx.whBreakMap,
                            onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit("close"))),
                            onShowSubComponent: _ctx.showSubComponent,
                            onRevertScrollPosition: _ctx.revertScrollPosition,
                            onUpdateAllData: _ctx.updateAllData
                          }, null, 8, ["event", "date", "users", "eventUserId", "isFutureEdit", "propsSiteData", "lunchBreakMap", "whBreakMap", "onShowSubComponent", "onRevertScrollPosition", "onUpdateAllData"])),
                    (_ctx.showLimitedEditPopup && !_ctx.loading && _ctx.event && _ctx.showPreview)
                      ? (_openBlock(), _createBlock(_component_LimitedEditPopup, {
                          key: 3,
                          event: _ctx.event,
                          onGoToEdit: _ctx.goToEdit,
                          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showLimitedEditPopup = false))
                        }, null, 8, ["event", "onGoToEdit"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 512))
              : _createCommentVNode("", true)
          ]),
          (_ctx.showChooseEditPopup)
            ? (_openBlock(), _createBlock(_component_EditEventPopup, {
                key: 1,
                instance: _ctx.event,
                isRequestSending: _ctx.isEditRequestSending,
                onEditEvents: _ctx.editEvents,
                onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showChooseEditPopup = false))
              }, null, 8, ["instance", "isRequestSending", "onEditEvents"]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}